module.exports = __webpack_public_path__ + "static/media/nodata.5294d213.jpg";